export default __webpack_public_path__ + "static/media/share.e8035b28.png";